import { useContext, useEffect, type FC } from "react";
import { LayoutActionsContext } from "src/contexts/layouts/LayoutContext";

interface ISetPageLoadingProps {
    loading: boolean;
}

const SetPageLoading: FC<ISetPageLoadingProps> = ({ loading }) => {
    const layoutContext = useContext(LayoutActionsContext);

    useEffect(() => {
        layoutContext.setLoading(loading);
    }, [loading, layoutContext]);

    return null;
};

export default SetPageLoading;
